import type { ReactNode } from 'react';
import { useIpadScale } from '../hooks/useIpadScale';
import { useIsCompact } from '../hooks/useIsCompact';

export function IpadShell({ children }: { children: ReactNode }) {
  const compact = useIsCompact();
  const scale = useIpadScale();

  if (compact) {
    // On phones / narrow browsers, skip the iPad frame entirely and let the
    // layout fill the viewport — otherwise everything is a scaled-down
    // 1366×1024 rectangle regardless of orientation.
    return <div className="compact-shell">{children}</div>;
  }

  return (
    <div id="stage">
      <div className="ipad-scale" style={{ transform: `scale(${scale})` }}>
        <div className="ipad">
          <div className="ipad-screen">{children}</div>
        </div>
      </div>
    </div>
  );
}
